import React from "react";
import PageTitle from "sc/ui/sites/oncall/components/PageTitle";
import { Row, Col, Panel } from "react-bootstrap";
import { connect } from "react-redux";
import { user } from "../../../selectors/users";
import { userPageLoad, userAddRequest } from "../../../actions/users";
import { push } from "react-router-redux";
import UserForm from "../../../components/forms/User";
import componentWithLoadTrigger from "sc/ui/components/hoc/componentWithLoadTrigger";

export const AddUserPage = connect(
  (state, ownProps) => ({
    user: user(state),
  }),
  (dispatch, ownProps) => ({
    onLoad: () => dispatch(userPageLoad()),
    onSave: formData => dispatch(userAddRequest(formData, ownProps.partnerId)),
    onUserList: () => dispatch(push(ownProps.backTo)),
  }),
)(
  componentWithLoadTrigger(props => {
    if (props.user === null) return <div />;
    return (
      <div id="add-user-page">
        <PageTitle title="Create User" />
        <div>
          <a id="back" style={{ cursor: "pointer" }} onClick={props.onUserList}>
            <span className="glyphicon  glyphicon-circle-arrow-left" />
            Back to users list
          </a>
        </div>
        <br />
        <Panel bsStyle="info">
          <Panel.Heading>
            <Panel.Title componentClass="h3">User data</Panel.Title>
          </Panel.Heading>
          <Panel.Body>
            <Row>
              <Col md={8} mdOffset={2}>
                <UserForm
                  user={props.user}
                  onSave={props.onSave}
                  disabled={props.user.saveUserDataInProgress}
                  backendError={props.user.saveUserDataError}
                />
              </Col>
            </Row>
          </Panel.Body>
        </Panel>
      </div>
    );
  }),
);



// WEBPACK FOOTER //
// ./src/sc/ui/sites/oncall/pages/admin/users/add-page.js